module.exports = __webpack_public_path__ + "static/media/492.e34d63e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/vehicleDetail/images/492.png
// module id = 760
// module chunks = 0